import { KeyRoundIcon } from 'lucide-react-native';
import { iconWithClassName } from './iconWithClassName';

iconWithClassName(KeyRoundIcon);
export { KeyRoundIcon };
